import * as React from "react";
import { WithStyle } from "utils/WithStyle";
import { GridContainer } from "./Grid.styled";
import { StyledGrid } from "./Styled";
import { GridProps } from "./types";

const GridComponent: React.FC<GridProps> = (props) => {
    const {
        alignItems,
        children,
        column,
        expanded,
        justify,
        direction,
        lg,
        md,
        row,
        sm,
        margin,
        marginLeft,
        marginRight,
        marginTop,
        marginBottom,
        columnGap,
        rowGap,
        customClasses,
    } = props;
    const isRow: boolean = row || !column;

    const classes = `${
        (!isRow ? "column" : "row") +
        ((isRow || !isRow) && expanded ? ` expanded` : "") +
        ((isRow || !isRow) && justify ? ` ${justify}` : "") +
        ((isRow || !isRow) && alignItems ? ` ${`align-${alignItems}`}` : "") +
        (!isRow && direction ? ` ${direction}` : "") +
        (!isRow && sm ? ` ${`sm-${sm}`}` : "") +
        (!isRow && md ? ` ${`md-${md}`}` : "") +
        (!isRow && lg ? ` ${`lg-${lg}`}` : "") +
        (margin ? ` margin-${margin}` : "") +
        (marginLeft ? ` ml-${marginLeft}` : "") +
        (marginRight ? ` marginRight-${marginRight}` : "") +
        (marginTop ? ` marginTop-${marginTop}` : "") +
        (marginBottom ? ` marginBottom-${marginBottom}` : "") +
        (columnGap ? ` column-gap-${columnGap}` : "") +
        (rowGap ? ` row-gap-${rowGap}` : "") +
        (customClasses ? ` ${customClasses}` : "")
    }`;

    return <GridContainer className={classes}>{children}</GridContainer>;
};

export const Grid: React.FC<GridProps> & WithStyle = Object.assign(
    GridComponent,
    {
        Style: StyledGrid,
    }
);
